import { SenderConfiguration } from '@/features/senders/types/sender.types';
import {
  getActiveSenderConfig,
  getSenderConfigInfo,
} from '@/utils/sender-config';
import { useMemo } from 'react';

export const useSenderConfiguration = (
  senderConfigurations?: SenderConfiguration[]
) => {
  const activeConfig = useMemo(() => {
    return getActiveSenderConfig(senderConfigurations);
  }, [senderConfigurations]);

  const configInfo = useMemo(() => {
    return getSenderConfigInfo(activeConfig || undefined);
  }, [activeConfig]);

  return {
    activeConfig,
    configInfo,
    hasConfiguration: !!activeConfig,
    sender: activeConfig?.sender,
    priority: activeConfig?.priority,
    isActive: activeConfig?.isActive ?? false,
    isVerified: activeConfig?.sender?.isVerified ?? false,
  };
};
